import { Link, NavLink } from 'react-router-dom';
import logo from '../../assets/images/logo.svg';
import './Header.css';

export default function Header() {
  return (
    <header className="header border-bottom bg-white">
      <div className="container d-flex align-items-center justify-content-between py-3">
        <Link to="/" className="header-brand text-decoration-none d-flex align-items-center gap-2">
          <img src={logo} alt="Bysetup" width="36" height="36" />
          <span className="header-brand-text fw-bold">Bysetup</span>
        </Link>

        <nav className="d-flex align-items-center gap-3">
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              `header-link text-decoration-none ${isActive ? 'header-link--active' : ''}`
            }
          >
            Blog
          </NavLink>

          <NavLink
            to="/sobre"
            className={({ isActive }) =>
              `header-link text-decoration-none ${isActive ? 'header-link--active' : ''}`
            }
          >
            Sobre
          </NavLink>

          <NavLink
            to="/contato"
            className={({ isActive }) =>
              `header-link text-decoration-none ${isActive ? 'header-link--active' : ''}`
            }
          >
            Contato
          </NavLink>
        </nav>
      </div>
    </header>
  );
}